"use client";

import createIcon from './util/createIcon';
export default createIcon('M2.61,21L1.61,19.27L11,13.85V3H13V13.85L22.39,19.27L21.39,21L12,15.58L2.61,21Z', 'Axis');